export default __webpack_public_path__ + "static/6-294eeca975d00a3d5e4112b1f7f92182.jpeg";